import { Box } from "@chakra-ui/layout";
import { getPadding } from "lib/utils/domsUtil"
import { chakra, HTMLChakraProps, Text } from "@chakra-ui/react";
import { HTMLMotionProps, motion } from "framer-motion";
import { FC } from 'react'

type Merge<P, T> = Omit<P, keyof T> & T;
type MotionBoxProps = Merge<HTMLChakraProps<"div">, HTMLMotionProps<"div">>;
export const MotionBox: FC<MotionBoxProps> = motion(chakra.div);

export const HelpPoint = ({ data, padding = 10, setActiveHelpId, activeHelpId }) => {
  const [px, py] = getPadding(padding);
  const width = data?.width + px * 2;
  const top = data?.top - py;
  const left = data?.left - px;

  return (
    <Box
      key={data.id} 
      position="absolute"
      top={top + window.scrollY}
      left={(left - 6) + (width / 2)}
    >
      <Box
        position="absolute"
        w="200px"
        maxW="200px"
        bgColor="rgba(0,0,0,0.75)"
        left="-100px"
        bottom="5px"
        p="12px 10px"
        id="help-box"
        zIndex="99999"
        borderRadius="12px"
        visibility={activeHelpId === data.id ? 'visible' : 'hidden'}
      >
        <Text id="help-text" variant="with-dark-bg" textAlign="center" size="sm">{data.content}</Text>
      </Box>

      <MotionBox
        as="aside"
        id="help-point"
        animate={{
          scale: [1, 1.3, 1],
        }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
          times: [0, 0.5, 1],
          repeat: Infinity,
          repeatType: "loop",
          repeatDelay: 0,
        }}
        bgColor="rgba(255, 102, 102, 0.65)"
        border="1px solid rgb(255, 102, 102)"
        borderRadius="50%"
        width="12px"
        height="12px"
        display="flex"
        position="absolute"
        zIndex="100"
        transitionDuration="0.2s"
        transitionProperty="all"
        transitionTimingFunction="ease"
        _hover={{
          cursor: 'pointer',
          bgColor: 'rgb(255, 102, 102)'
        }}
        onClick={() => setActiveHelpId(data.id)}
      />
    </Box>
  )
}
